// extracted by mini-css-extract-plugin
export default {"card":"b0VJv","inner":"dK4Qk","preview":"QUWGZ","main":"monqR","name":"UbxSr","status":"cM9Nk","info":"L44jo","actions":"v_ZIm","action":"AsPsY","createdAt":"uI3sN"};